import React, { useState } from "react";
import styled from "styled-components";
import { LayoutProps } from "../../interface";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import OffCanvas from "../OffCanvas";


const WrapperContainer = styled.div`
  overflow-x: hidden !important;
`;

const Layout = ({ children, from, background }: LayoutProps) => {
  const [canvas, setCanvas] = useState(false);

  return (
    <>
  
      <WrapperContainer className="position-relative">
        <OffCanvas
          from={from as string}
          setCanvas={setCanvas}
          canvas={canvas}
        />
        <Header
          from={from as string}
          setCanvas={setCanvas}
          background={background}
        />
        {children}
        <Footer background={background} />
      </WrapperContainer>
    </>
  );
};

export default Layout;
